import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {toggleMenu} from '/src/js/custom/togglemenu'

document.addEventListener('DOMContentLoaded', function () {
    var scrollBtn = document.querySelector('.scroll');

    if (scrollBtn) {
        var sectionHeight = document.querySelector('.block_hero.big').offsetHeight;

        scrollBtn.addEventListener('click', () => {
            window.scrollTo({
                behavior: 'smooth',
                top: sectionHeight + 65
            });
        });
    }

    var heroSearch = document.querySelector('.hero-search');
    var sooqrSearch = document.querySelector('#sooqrSearch');

    function simulateClick() {
        toggleMenu();
        sooqrSearch.focus();
        sooqrSearch.value = heroSearch.value;
        heroSearch.value = '';
    }

    if (heroSearch) {
        heroSearch.addEventListener('keyup', simulateClick);
    }
});

var sectionVideo = document.querySelectorAll('.block_hero');

if (sectionVideo) {
    sectionVideo.forEach(function (el) {

        var videoHolder = el.querySelector('.video-holder');
        var video = el.querySelector('.video-holder video');
        if (video) {
            var videoSource = video.getElementsByTagName('source');
            var closeButton = videoHolder.querySelector('.close-video');
        }
        var playButtons = el.querySelectorAll('.block_hero .button-play');

        playButtons.forEach(function (el) {
            el.addEventListener('click', playVideo);
        });

        if (video) {
            closeButton.addEventListener('click', stopVideo);
        }

        function playVideo() {
            const videoWebm = this.getAttribute('data-video-webm');
            const videoMp4 = this.getAttribute('data-video-mp4');

            videoSource[0].src = videoWebm;
            videoSource[1].src = videoMp4;
            videoHolder.style.display = 'block';
            el.classList.add('video-play')

            video.load();
            video.play();
        }

        function stopVideo() {
            videoHolder.style.display = 'none';
            el.classList.remove('video-play')
            video.pause();
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.matchMedia({
        '(min-width: 1024px)': function () {
            var tl = gsap.timeline({

                scrollTrigger: {
                    trigger: '.block_hero',
                    start: 'top +=136',
                    end: 'bottom top+=136',
                    pin: false,
                    scrub: true
                }
            });

            tl.to('.block_hero .image img', {y: 250, duration: 2});
            tl.to('.block_hero .kader-shape', {y: 0, duration: 2}, '>-=2');
        }
    });
});
